import Magnifier from './magnifier'
import DrawLabel from './drawLabel'
import DrawShieldManually from './drawShieldManually'
import DrawShieldLine from './drawShieldLine'
import InspectShieldLine from './inspectShieldLine'
import InspectLabel from './inspectLabel'

export const tools = {
  TOOL_MAGNIFIER: new Magnifier(),
  TOOL_DRAW_LABEL: new DrawLabel(),
  TOOL_DRAW_SHIELD_MANUALLY: new DrawShieldManually(),
  TOOL_DRAW_SHIELD_LINE: new DrawShieldLine(),
  TOOL_INSPECT_SHIELD_LINE: new InspectShieldLine(),
  TOOL_INSPECT_LABEL: new InspectLabel(),
}

export default { tools }
